import React from "react";
import CategoriesScroll, { Category } from "./CategoriesScroll";
import PrimaryButtonWithIconAdd from "../../../ui/PrimaryButtonWithIconAdd";

interface Props {
  categories: Category[];
  buttonAddLinkPath: string;
  buttonLinkPath: string;
  buttonLabel:string
  selectedCategory: string,
  showAdd:boolean,
  notShowAddButton?:boolean,
  showAllLable?:boolean
}

const CategoriesSection: React.FC<Props> = ({
  categories,
  buttonAddLinkPath,
  buttonLinkPath,
  buttonLabel,
  selectedCategory,
  showAdd,
  notShowAddButton,
  showAllLable=true
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6 w-full">
      {/* Scrollable Categories */}
      <CategoriesScroll
        showAllLable={showAllLable? true : false}
        categories={categories}
        buttonAddLinkPath={buttonAddLinkPath}
        selectedCategory={selectedCategory}
        showAdd={showAdd}
      />

      {/* Add Button */}
      {
        !notShowAddButton&&
      <PrimaryButtonWithIconAdd buttonLabel={buttonLabel} buttonLinkPath={buttonLinkPath}/>
      }
    </div>
  );
};

export default CategoriesSection;
